module.exports = __webpack_public_path__ + "12ad902bc280056305993f4c18d59e81.jpg";